module.exports = __webpack_public_path__ + "img/cup.7847b81e.svg";